import DT from '@repo/alt/DependencyTypes'
import { AppApiGateway } from '@repo/api/web/AppApiGateway'
import type {
  ListingOptionsOfProductFilterOptions,
  ProductDto,
  ProductListItemPage,
  ProductsListGetRequestQuery,
} from '@repo/api/web/models'
import { inject, injectable } from 'inversify'

@injectable()
export class ProductsService {
  protected appConfig: ReturnType<typeof useAppConfig>

  constructor(
    @inject(AppApiGateway)
    readonly api: AppApiGateway,
  ) {
    this.appConfig = useAppConfig()
  }

  /**
   * Получить список продуктов с фильтрацией и пагинацией (GET)
   */
  list(query: ProductsListGetRequestQuery): Promise<ProductListItemPage> {
    return this.api.productsListGet(this.appConfig.host, query)
  }

  /**
   * Получить список продуктов с фильтрацией и пагинацией (POST)
   */
  listFiltered(model: ListingOptionsOfProductFilterOptions): Promise<ProductListItemPage> {
    return this.api.productsListPost(this.appConfig.host, model)
  }

  /**
   * Получить продукт по ID
   */
  get(productId: number): Promise<ProductDto> {
    return this.api.productsGet(productId, this.appConfig.host)
  }
}
